// extracted by mini-css-extract-plugin
export default {"div":"not_found_div__n3GQw","main_text":"not_found_main_text__nfLka","text":"not_found_text__1JMmX"};